export const ClosedEyeSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3.75 3.125l12.5 13.75M12.101 12.313a3.125 3.125 0 01-4.203-4.625"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.781 5.36C2.594 6.968 1.25 10 1.25 10s2.5 5.625 8.75 5.625a9.211 9.211 0 004.219-.984M16.297 13.21C18 11.688 18.75 10 18.75 10S16.25 4.375 10 4.375a9.68 9.68 0 00-1.617.133M10.586 6.93a3.117 3.117 0 012.523 2.773"
      />
    </svg>
  );
};
